<template>
    <div
        class="expenses-detail-visualization"
        element-loading-spinner="presupuesto-loader"
    >
        <div class="row">
            <div class="col-sm-8">
                <el-radio-group v-model="periodo">
                    <el-radio-button
                        v-for="p in periodos"
                        :key="p"
                        :label="p"
                    ></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-sm-4">
                <form @submit.prevent="refreshData">
                    <div class="row">
                        <div class="col-sm-8">
                            <el-input
                                prefix-icon="el-icon-search"
                                placeholder="Buscar..."
                                v-model="search"
                                clearable
                            ></el-input>
                        </div>
                        <div class="col-sm-4">
                            <button class="btn btn-primary btn-block">
                                Buscar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br />
        <el-table
            v-loading="loading"
            :data="data"
            stripe
            @sort-change="sortChange"
        >
            <el-table-column
                label="% del Ppto"
                :width="100"
                class-name="percentage"
            >
                <template slot-scope="scope">
                    <div>
                        {{
                            scope.row.sum / sum < 0.001
                                ? '0.00%'
                                : numeral(scope.row.sum / sum).format('0.00%')
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="nombre_beneficiario"
                label="Nombre Proveedor/Receptor"
                :width="300"
            ></el-table-column>
            <el-table-column prop="beneficiario" label="RUT">
                <template slot-scope="scope">{{
                    !scope.row.persona
                        ? rutFormatter(scope.row.beneficiario)
                        : 'No disponible'
                }}</template>
            </el-table-column>
            <el-table-column
                label="Principales Instituciones Asociadas"
                :width="300"
            >
                <template slot-scope="scope">
                    <horizontal-stacked-chart
                        v-if="scope.row.partidas"
                        :data="scope.row.partidas"
                        :dimensions="{ ordinal: ['beneficiario', 'partida'] }"
                        :color="color"
                    ></horizontal-stacked-chart>
                </template>
            </el-table-column>
            <el-table-column
                label="Monto"
                prop="sum"
                sortable="custom"
                class-name="amount"
            >
                <template slot-scope="scope">
                    <div>{{ numeral(scope.row.sum).format('$0,0') }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Detalle" :width="100">
                <template slot-scope="scope">
                    <a
                        :href="'/providers/' + scope.row.beneficiario"
                        class="btn btn-primary btn-nofill"
                    >
                        Ver
                        <i class="material-icons">arrow_forward</i>
                    </a>
                </template>
            </el-table-column>
        </el-table>
        <br />
        <div class="text-center">
            <el-pagination
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import * as d3 from 'd3';
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import rutFormatter from '../../Methods/RutFormatter';
import HorizontalStackedChart from '../Charts/HorizontalStacked';

export default {
    data: function() {
        return {
            periodo: this.$store.state.defaultYear,
            periodos: [],
            loading: false,
            pageSize: 50,
            currentPage: 1,
            total: 0,
            sum: 0,
            search: '',
            orderBy: null,
            data: []
        };
    },
    components: {
        HorizontalStackedChart
    },
    methods: {
        moment: moment,
        numeral: numeral,
        rutFormatter: rutFormatter,
        refreshData: function() {
            this.loading = true;

            Promise.all([
                axios
                    .get('/api/v1/elasticsearch', {
                        params: {
                            q: this.search,
                            periodo: this.periodo,
                            size: this.pageSize,
                            from: (this.currentPage - 1) * this.pageSize,
                            sort: this.orderBy
                                ? JSON.stringify([
                                      { [this.orderBy[0]]: this.orderBy[1] }
                                  ])
                                : undefined
                        }
                    })
                    .then(response => {
                        this.loading = false;
                        this.total = response.data.total;
                        this.data = response.data.hits.map(d => {
                            return d._source;
                        });
                    }),
                axios
                    .get('/api/v1/data/pagos', {
                        params: {
                            where: JSON.stringify({
                                periodo: this.periodo
                            }),
                            sum: JSON.stringify('devengo')
                        }
                    })
                    .then(response => {
                        //this.loading = false;
                        this.sum = response.data[0].sum;
                    })
            ]).then(() => {
                this.loading = false;
            });
        },
        debouncedRefreshData: _.debounce(function() {
            this.refreshData();
        }, 1000),
        sortChange: function(a) {
            if (a.prop === null) this.orderBy = null;
            else
                this.orderBy = [
                    a.prop,
                    a.order === 'ascending' ? 'asc' : 'desc'
                ];
        },
        openOC: function(id) {
            this.dialogOCId = id;
            this.dialogVisible = true;
        }
    },
    computed: {
        color: function() {
            return d3.scaleOrdinal([
                '#25AF7C',
                '#13B0FF',
                '#F7B538',
                '#1D91C0',
                '#41B6C4',
                '#502670',
                '#772D60',
                '#73B61E',
                '#C67100',
                '#9A1800',
                '#5090A3',
                '#5E9AD2',
                '#00AA00',
                '#006060',
                '#1BA39C',
                '#E76E3C',
                '#F64747',
                '#D24D57',
                '#00A4A6',
                '#1C2833',
                '#34515E',
                '#D25299'
            ]);
        }
    },
    watch: {
        currentPage: function(value) {
            //console.log('a');
            this.refreshData();
            window.history.pushState({ page: value }, null, '#page=' + value);
        },
        orderBy: function() {
            //console.log('b');
            this.refreshData();
        },
        periodo: function(value) {
            //console.log('b');
            this.$store.commit('setDefaultYear', value);
            this.refreshData();
        }
        //search: function(){
        //    this.debouncedRefreshData();
        //}
    },
    mounted: function() {
        //console.log('mount');
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });

        window.onpopstate = event => {
            if (event.state) this.currentPage = event.state.page;
            else this.currentPage = 1;
        };
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/ProvidersRanking.vue